import { useParams } from 'react-router-dom';
import shortData from '../data/partialData.json';
import heartIcon from '../assets/icons/sky-heart.png';
import { Commission } from '../types/types';
import styles from './CommissionPage.module.css';

function CommissionPage() {
  type CommissionPageParams = {
    paramId: string;
  }
  
  const {paramId} = useParams<CommissionPageParams>();
  // const commissionData = commissionsMap.hasOwnProperty(paramId) ? 
  // commissionsMap.keys(paramId) : null;
  const commission: Commission = shortData.commissions.filter((c) => c.id === paramId)[0];

  const ImagesContainer = () => {
    return (
      <div className={styles.imagesContainer}>
        {commission.imageUrls.map(
          (imgUrl) => <img 
                        key={imgUrl}
                        className={styles.image} 
                        src={imgUrl}
                        alt="progress drawing">
                      </img>
        )}
      </div>
    )
  }

  const CommissionContainer = () => {
    if (commission) {
      return (
        <div>
          {commission.isPrivate && 
          <p className={styles.hint}>This page is accessible only to those with the URL</p>}
          <h2 className={styles.title}>{commission.title}</h2>
          <div className={styles.statusSection}>
            <img className={styles.heartIcon} src={heartIcon} alt="heart icon"></img>
            <p className={styles.label}>Compensation: {commission.amountPayed} of {commission.amountAgreed} hearts</p>
            <p className={styles.label}>Status: {commission.status}</p>
          </div>
          <div className={styles.box}>
            <div className={styles.infoSection}>
              <p className={styles.label}>Commission Details</p>
              <p>{commission.commissionInfo}</p>
            </div>
            <hr className={styles.separator}/>
            <div>
              <p className={styles.label}>Progress Drawings</p>
              {ImagesContainer()}
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <h2>Oops! This page does not exist ;w;</h2>
      </div>
    )
  }

  return (
    <div className={styles.commissionPage}>
      {CommissionContainer()}
    </div>
  );
}

export default CommissionPage;